import {combineReducers} from '@modifi/redux'

import submitReducer from './store/submit'

export default combineReducers({
  submit: submitReducer,
})
